GatorSurvey.app.directive('gsGvsCheck', ['$location', gsGvsCheck]);

function gsGvsCheck($location) {
    return {
        require: '?ngModel',
        restrict: 'AE',
        scope: {            
            gvsCheckText: '=?ngModel',
            gsvInputValue: '=?gsvInputValue',
            gsvUse: '=?gsvUse',
            gsvType: '=?gsvType',
            gsvPopulated: '=?gsvPopulated'
        },
        controller: function($scope, $rootScope) {
            console.log($scope);
        },
        link: function ($scope, elem, attrs) {

            var gsvs = $location.search();
            var keys = Object.keys(gsvs);

            if ($scope.gsvType === "input") {
                if ($scope.gsvUse && typeof $scope.gvsCheckText === "undefined") {
                    if (typeof gsvs[$scope.gsvInputValue] !== "undefined") {
                        $scope.gvsCheckText = gsvs[$scope.gsvInputValue];
                    }
                } else if ($scope.gsvUse && $scope.gvsCheckText.toString() === "") {
                    if (typeof gsvs[$scope.gsvInputValue] !== "undefined") {
                        $scope.gvsCheckText = gsvs[$scope.gsvInputValue];
                    }
                }
                return;
            }

            if (typeof $scope.gvsCheckText === "undefined")
                return;

            for (var i = 0; i < keys.length; i++)
            {
                if (keys[i].toLocaleLowerCase().indexOf("gsv_") === -1) 
                    continue;
                if ($scope.gvsCheckText.indexOf("#[" + keys[i] + "]") === -1)
                    continue;
                $scope.gvsCheckText = $scope.gvsCheckText.replace("#[" + keys[i] + "]", gsvs[keys[i]]);
            }
            var regex = /\#\[gsv_(\w+)\]/igm;
            $scope.gvsCheckText = $scope.gvsCheckText.replace(regex, "");
            
            if (typeof $scope.gsvType !== "undefined" && $scope.gsvType === "html") {
                angular.element(elem).html($scope.gvsCheckText);
                return;
            }

            
            angular.element(elem).text($scope.gvsCheckText);

        }
    };
}
